import React, { useEffect, useRef, useState } from "react";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

export default function TrackOrder() {
  const { t, lang } = useLang();
  const request = useRef(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => () => request.current?.abort(), []);
  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    const data = new FormData(event.currentTarget);
    const controller = new AbortController();
    request.current = controller;
    setBusy(true); setMessage("");
    try {
      await api.post("/orders/guest-access", { order_number: data.get("order_number"), email: data.get("email"), lang }, { timeout: 20000, signal: controller.signal });
      if (!controller.signal.aborted) setMessage("tracking.checkEmail");
    } catch (error) {
      if (!controller.signal.aborted) setMessage(error.response?.status === 429 ? "tracking.rateLimited" : "tracking.unavailable");
    } finally {
      if (!controller.signal.aborted) setBusy(false);
    }
  }
  return <main className="mx-auto max-w-lg px-4 py-12">
    <h1 className="font-display text-3xl font-bold text-navy">{t("tracking.title")}</h1>
    <p className="my-5 text-muted-foreground">{t("tracking.hint")}</p>
    <form onSubmit={submit} className="space-y-5">
      <label className="block">{t("tracking.number")}<input name="order_number" required maxLength={100} className="mt-2 block w-full rounded-lg border p-3" /></label>
      <label className="block">{t("tracking.email")}<input name="email" type="email" autoComplete="email" required maxLength={254} className="mt-2 block w-full rounded-lg border p-3" /></label>
      <button disabled={busy} className="btn-gold w-full rounded-full p-3 disabled:opacity-50">{busy ? t("checkout.loadingOrder") : t("tracking.submit")}</button>
    </form>
    {message && <p role="status" className="mt-6 rounded-xl bg-cream-card p-4">{t(message)}</p>}
  </main>;
}
